// extracted by mini-css-extract-plugin
export default {"iconWrapper":"list_iconWrapper__-cQud","icon":"list_icon__puHHF","status":"list_status__dN6TT","Active":"list_Active__unjl4","Inactive":"list_Inactive__SgGcy"};